import styled from "styled-components";

import crossImg from "../../images/icon_close.svg";
import { TOOLTIPS } from "../../utils/tooltipConstants";
import { BaseButton, TooltipBox } from "./BaseButton";

const IconButton = styled(BaseButton)`
  background-color: ${({ theme }) => theme.colors.accentRed};
  & :hover > ${TooltipBox} {
    background-color: ${({ theme }) => theme.colors.accentRed};
  }
  & > img {
    filter: invert(1);
  }
`;

export function RejectButton(props) {
  const { tooltipText, onClick } = props;
  const tooltipContent = tooltipText ? tooltipText : TOOLTIPS.reject.text;
  return (
    <IconButton onClick={onClick} tooltip={tooltipContent}>
      <img src={crossImg} alt={tooltipContent} />
    </IconButton>
  );
}
